import { NotificationConfiguration } from '../notification.templates';

export const MEETING_MINUTES_ACCEPT_REVIEW: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> has accepted the minutes without changes.`,
  email: {
    ctaKey: 'go_to_meeting_minutes',
  },
};
